import {useState} from 'react';
import {useQueryClient} from 'react-query';
import {useNavigate} from 'react-router-dom';
import Button from '../../../../components/button';
import MainFooter from '../../../../components/mazraeKit/footers/footerMain';
import SpinnerLoading from '../../../../components/SpinnerLoading';
import useDeleteLoanRequest from '../../../../services/hookService/deleteLoanRequest/useDeleteLoanRequest';
import useGetListLoanRequest from '../../../../services/hookService/getListLoanRequest/useGetListLoanRequest';
import {
  LoanRequestStatus,
  showCancelButtonByLoanStatus,
} from '../../../myAccount/my-credits/consts/loanStatus';
import CancelLoanBottomSheet from '../../receiveCredit/cancelLoanRequest/CancelLoanBottomSheet';
import CancelLoanConfirmModal from '../../receiveCredit/cancelLoanRequest/CancelLoanConfirmModal';
import MultiStepComponent from '../../receiveCredit/MultiStepComponent';
import {receiveCreditSteps} from '../../receiveCredit/receiveCreditSteps';
import {ValidationCard} from '../../receiveCredit/step1-validation/status2/ValidationsPending';
import LoanRequestHeader from '../../receiveCredit/step3-completeDocs/components/LoanRequestHeader';
import {useMultiStepForm} from '../../receiveCredit/useMultiStepForm';
import {receiveLoanSteps} from '../receiveLoanSteps';
import AcceptedLoanReceive from './AcceptedLoanReceive';
import RejectLoanReceive from './RejectLoanReceive';

const ReceiveLoanPage = () => {
  const queryClient = useQueryClient();

  const navigate = useNavigate();
  const {stepNumber} = useMultiStepForm();

  // Get the list of loan requests
  const {data: listLoanRequest, isLoading: isLoadingListLoanRequest} =
    useGetListLoanRequest({is_finished: false});
  const loanItem = listLoanRequest as ILoanRequestItem | undefined;

  // ---------------- Cancel Loan States ----------------
  const [isOpenCancelLoanBtm, setIsOpenCancelLoanBtm] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  if (isLoadingListLoanRequest) {
    return (
      <div className="grid h-full place-content-center">
        <SpinnerLoading />
      </div>
    );
  }
  const {mutate, isLoading: isDeleteLoanLoading} = useDeleteLoanRequest();

  const handleButtonAction = () => {
    if (loanItem?.status === LoanRequestStatus.REJECTED_LOAN_REQUEST) {
      mutate(listLoanRequest?.guid!, {
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: ['get-list-loan-request'],
          });
          window.location.href = '/my-credits/startLoanCredit'; // Navigate AND refresh. this is needed to avoid white screen step when user comes back to step pages
        },
      });
    } else navigate('/my-credits');
  };

  return (
    <div className="flex flex-col w-full bg-white h-dvh">
      {/* ---------------- HEADER ---------------- */}
      <LoanRequestHeader
        backPath="/my-credits"
        title="دریافت وام"
        loanRequestGuid={listLoanRequest?.guid}
        showCancelButton={showCancelButtonByLoanStatus(
          listLoanRequest?.status as LoanRequestStatus,
        )}
      />

      {/* ---------------- CONTENT ---------------- */}
      <div className="flex flex-col w-full h-full gap-3 p-3 overflow-y-auto">
        <MultiStepComponent
          steps={loanItem?.is_direct ? receiveLoanSteps : receiveCreditSteps}
          currentStep={stepNumber}
        />

        {/* Pending status */}
        {loanItem?.status === LoanRequestStatus.PENDING_FINAL_REVIEW && (
          <>
            <span className="text-gray-800 font-Medium text-md">وضعیت وام</span>

            <span className="text-sm leading-5 text-gray-800">
              درخواست دریافت وام شما با موفقیت ثبت شد و در حال بررسی است. نتیجه
              از طریق پیامک به شما اطلاع رسانی می‌شود.
            </span>

            <ValidationCard />
          </>
        )}

        {/* Accepted status */}
        {loanItem?.status === LoanRequestStatus.COMPLETED && (
          <AcceptedLoanReceive />
        )}

        {/* Rejected status */}
        {loanItem?.status === LoanRequestStatus.REJECTED_LOAN_REQUEST && (
          <RejectLoanReceive loanRequestGuid={loanItem.guid} />
        )}
      </div>

      {/* ---------------- FOOTER ---------------- */}
      <div className="w-full flex flex-col gap-2  bg-white shadow-[0_-1px_6px_0_rgba(0,0,0,0.1)]">
        <div className="p-3">
          {(loanItem?.status === LoanRequestStatus.PENDING_FINAL_REVIEW ||
            loanItem?.status === LoanRequestStatus.REJECTED_LOAN_REQUEST) && (
            <Button
              className="w-full"
              isLoading={isDeleteLoanLoading}
              disabled={isDeleteLoanLoading}
              onClick={handleButtonAction}
            >
              متوجه شدم
            </Button>
          )}

          {loanItem?.status === LoanRequestStatus.COMPLETED && (
            <Button className="w-full" onClick={() => navigate('bank-url')}>
              ورود به اپلیکیشن بانک
            </Button>
          )}
        </div>

        <MainFooter isScrolling={false} />
      </div>

      {/* Bottom Sheet */}
      <CancelLoanBottomSheet
        isOpen={isOpenCancelLoanBtm}
        setIsOpen={setIsOpenCancelLoanBtm}
        onConfirm={() => setShowConfirmModal(true)}
      />

      <CancelLoanConfirmModal
        isOpen={showConfirmModal}
        setIsOpen={setShowConfirmModal}
        loanGuid={loanItem?.guid as string}
      />
    </div>
  );
};
export default ReceiveLoanPage;
